const countryTranslations = {
  ad: "Андора",
  ae: "Обединени арабски емирства",
  af: "Афганистан",
  ag: "Антигуа и Барбуда",
  ai: "Ангуила",
  al: "Албания",
  am: "Армения",
  ao: "Ангола",
  ar: "Аржентина",
  as: "Американска Самоа",
  at: "Австрия",
  au: "Австралия",
  aw: "Аруба",
  ax: "Оландски острови",
  az: "Азербайджан",
  ba: "Босна и Херцеговина",
  bb: "Барбадос",
  bd: "Бангладеш",
  be: "Белгия",
  bf: "Буркина Фасо",
  bg: "България",
  bh: "Бахрейн",
  bi: "Бурунди",
  bj: "Бенин",
  bl: "Сен Бартелеми",
  bm: "Бермудски острови",
  bn: "Бруней Даруссалам",
  bo: "Боливия",
  bq: "Карибска Нидерландия",
  br: "Бразилия",
  bs: "Бахамски острови",
  bt: "Бутан",
  bw: "Ботсвана",
  by: "Беларус",
  bz: "Белиз",
  ca: "Канада",
  cc: "Кокосови острови (острови Кийлинг)",
  cd: "Конго (Киншаса)",
  cf: "Централноафриканска република",
  cg: "Конго (Бразавил)",
  ch: "Швейцария",
  ci: "Кот д’Ивоар",
  ck: "острови Кук",
  cl: "Чили",
  cm: "Камерун",
  cn: "Китай",
  co: "Колумбия",
  cr: "Коста Рика",
  cu: "Куба",
  cv: "Кабо Верде",
  cw: "Кюрасао",
  cx: "остров Рождество",
  cy: "Кипър",
  cz: "Чехия",
  de: "Германия",
  dj: "Джибути",
  dk: "Дания",
  dm: "Доминика",
  do: "Доминиканска република",
  dz: "Алжир",
  ec: "Еквадор",
  ee: "Естония",
  eg: "Египет",
  eh: "Западна Сахара",
  er: "Еритрея",
  es: "Испания",
  et: "Етиопия",
  fi: "Финландия",
  fj: "Фиджи",
  fk: "Фолкландски острови",
  fm: "Микронезия",
  fo: "Фарьорски острови",
  fr: "Франция",
  ga: "Габон",
  gb: "Обединеното кралство",
  gd: "Гренада",
  ge: "Грузия",
  gf: "Френска Гвиана",
  gg: "Гърнзи",
  gh: "Гана",
  gi: "Гибралтар",
  gl: "Гренландия",
  gm: "Гамбия",
  gn: "Гвинея",
  gp: "Гваделупа",
  gq: "Екваториална Гвинея",
  gr: "Гърция",
  gt: "Гватемала",
  gu: "Гуам",
  gw: "Гвинея-Бисау",
  gy: "Гаяна",
  hk: "Хонконг, САР на Китай",
  hn: "Хондурас",
  hr: "Хърватия",
  ht: "Хаити",
  hu: "Унгария",
  id: "Индонезия",
  ie: "Ирландия",
  il: "Израел",
  im: "остров Ман",
  in: "Индия",
  io: "Британска територия в Индийския океан",
  iq: "Ирак",
  ir: "Иран",
  is: "Исландия",
  it: "Италия",
  je: "Джърси",
  jm: "Ямайка",
  jo: "Йордания",
  jp: "Япония",
  ke: "Кения",
  kg: "Киргизстан",
  kh: "Камбоджа",
  ki: "Кирибати",
  km: "Коморски острови",
  kn: "Сейнт Китс и Невис",
  kp: "Северна Корея",
  kr: "Южна Корея",
  kw: "Кувейт",
  ky: "Кайманови острови",
  kz: "Казахстан",
  la: "Лаос",
  lb: "Ливан",
  lc: "Сейнт Лусия",
  li: "Лихтенщайн",
  lk: "Шри Ланка",
  lr: "Либерия",
  ls: "Лесото",
  lt: "Литва",
  lu: "Люксембург",
  lv: "Латвия",
  ly: "Либия",
  ma: "Мароко",
  mc: "Монако",
  md: "Молдова",
  me: "Черна гора",
  mf: "Сен Мартен",
  mg: "Мадагаскар",
  mh: "Маршалови острови",
  mk: "Северна Македония",
  ml: "Мали",
  mm: "Мианмар (Бирма)",
  mn: "Монголия",
  mo: "Макао, САР на Китай",
  mp: "Северни Мариански острови",
  mq: "Мартиника",
  mr: "Мавритания",
  ms: "Монтсерат",
  mt: "Малта",
  mu: "Мавриций",
  mv: "Малдиви",
  mw: "Малави",
  mx: "Мексико",
  my: "Малайзия",
  mz: "Мозамбик",
  na: "Намибия",
  nc: "Нова Каледония",
  ne: "Нигер",
  nf: "остров Норфолк",
  ng: "Нигерия",
  ni: "Никарагуа",
  nl: "Нидерландия",
  no: "Норвегия",
  np: "Непал",
  nr: "Науру",
  nu: "Ниуе",
  nz: "Нова Зеландия",
  om: "Оман",
  pa: "Панама",
  pe: "Перу",
  pf: "Френска Полинезия",
  pg: "Папуа-Нова Гвинея",
  ph: "Филипини",
  pk: "Пакистан",
  pl: "Полша",
  pm: "Сен Пиер и Микелон",
  pr: "Пуерто Рико",
  ps: "Палестински територии",
  pt: "Португалия",
  pw: "Палау",
  py: "Парагвай",
  qa: "Катар",
  re: "Реюнион",
  ro: "Румъния",
  rs: "Сърбия",
  ru: "Русия",
  rw: "Руанда",
  sa: "Саудитска Арабия",
  sb: "Соломонови острови",
  sc: "Сейшели",
  sd: "Судан",
  se: "Швеция",
  sg: "Сингапур",
  sh: "Света Елена",
  si: "Словения",
  sj: "Свалбард и Ян Майен",
  sk: "Словакия",
  sl: "Сиера Леоне",
  sm: "Сан Марино",
  sn: "Сенегал",
  so: "Сомалия",
  sr: "Суринам",
  ss: "Южен Судан",
  st: "Сао Томе и Принсипи",
  sv: "Салвадор",
  sx: "Синт Мартен",
  sy: "Сирия",
  sz: "Есватини",
  tc: "острови Търкс и Кайкос",
  td: "Чад",
  tg: "Того",
  th: "Тайланд",
  tj: "Таджикистан",
  tk: "Токелау",
  tl: "Източен Тимор",
  tm: "Туркменистан",
  tn: "Тунис",
  to: "Тонга",
  tr: "Турция",
  tt: "Тринидад и Тобаго",
  tv: "Тувалу",
  tw: "Тайван",
  tz: "Танзания",
  ua: "Украйна",
  ug: "Уганда",
  us: "Съединени щати",
  uy: "Уругвай",
  uz: "Узбекистан",
  va: "Ватикан",
  vc: "Сейнт Винсънт и Гренадини",
  ve: "Венецуела",
  vg: "Британски Вирджински острови",
  vi: "Американски Вирджински острови",
  vn: "Виетнам",
  vu: "Вануату",
  wf: "Уолис и Футуна",
  ws: "Самоа",
  ye: "Йемен",
  yt: "Майот",
  za: "Южна Африка",
  zm: "Замбия",
  zw: "Зимбабве"
};
export default countryTranslations;